import type { CSSProperties } from 'react';
import { getSlaCurrencyConfig } from '~/app/landing/sla/shared/utils/sla-currency.utils';

type Props = {
  code: string;
  size?: number;
  title?: string;
  style?: CSSProperties;
};

export function SlaCurrencyIcon({ code, size = 16, title, style }: Props) {
  const config = getSlaCurrencyConfig(code);

  if (!config) {
    return <span title={title}>{code}</span>;
  }

  const Icon = config.icon;

  return (
    <span
      className="sla-currency-badge"
      title={title}
      style={{
        color: config.color,
        background: `${config.color}14`,
        ...style,
      }}
    >
      <Icon size={size} stroke={1.8} />
    </span>
  );
}
